import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { AutosuggestService } from '../autosuggest.service';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { environment } from '../../environments/environment';
import { EventEmitter } from "@angular/core";
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-package-report',
  templateUrl: './package-report.component.html',
  styleUrls: ['./package-report.component.css']
})
export class PackageReportComponent implements OnInit {
  dataSource;
  displayedColumns = ['sno', 'service_category', 'actions'];
  p: number = 1;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  columnNames = [{
    id: 'sno',
    value: 'S.No.',

  }, {
    id: 'service_category',
    value: 'Service Category',
  },
  {
    id: 'actions',
    value: 'Action',
  }
  ];



  @ViewChild('fileInput') fileInput;
  private appURL: string = environment.apiUrl;
  private uploadURL: string = environment.uploadUrl;
  public myFocusTriggeringEventEmitter = new EventEmitter<boolean>();
  myOptions: INgxMyDpOptions = {
    dateFormat: 'dd/mm/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 }
    // This will disable dates starting from tomorrow
  };
  // Initialized to specific date (09.10.2018)
  model2: any = { date: { year: 2018, month: 10, day: 9 } };
  month1: any = {};
  wbetot_exp: any;
  mbetot_exp: any;
  model: any = {};
  user: any = {};
  results: any = {};
  currentUser: any = {};
  currentOrg: any;
  sessionData: any = {};
  searching = false;
  searchFailed = false;
  hideSearchingWhenUnsubscribed = new Observable(() => () => this.searching = false);
  certList: any = [];
  certificate: any = {};
  cert: any = {};
  contId: number;
  mask: any[] = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  tinmask: any[] = [/[0-9]/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  certmask: any[] = [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  userType: number;
  showLoader: boolean;
  wbe_goal: number;
  mbe_goal: number;
  dataresult: any = [];
  recordsperpage: number = 25;
  datass: any = [];
  sortOrder = 0;
  AutoProductOffer: any = [];
  gstEnabled: boolean = false;
  cgst: number = 0;
  sgst: number = 0;
  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _flashMessagesService: FlashMessagesService

  ) {
  }

  covenants: any = [
    { provinceID: 1 },
    { provinceID: 2 },
    { provinceID: 3 },
    { provinceID: 4 },
    { provinceID: 5 },
  ];

  openCoverages = false;
  indexSelectedCoverage = 1;

  ngOnInit(): void {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this.gstEnabled = this.currentUser['gstEnabled'];
    if (this.gstEnabled == true) {
      // this.cgst = 0;
      // this.sgst = 0;
      this.cgst = this.currentUser['cgst'];
      this.sgst = this.currentUser['sgst'];
    } else {
      this.cgst = 0;
      this.sgst = 0;
    }
    this.loginservice.getserviceoffered('', '8', '', '', this.model, this.currentUser)
      .subscribe(
        data => {
          if (data['comp_details'].length > 0) {
            this.AutoProductOffer = data['comp_details'];
          } else {
            this.AutoProductOffer = [];
          }
        }, error => { alert('Network Error getserviceoffered API'); });

    this.model['start_date'] = '';
    this.model['service_category'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.model['f_name'] = '';
    this.model['phone'] = '';
    // this.displayedColumns = this.columnNames.map(x => x.id);
    this.getMembershipReport('');

    this.covenants.forEach((_covenants) => {
      _covenants.isExpanded = false;
    });
  }

  onDateChanged(type, event: IMyDateModel): void {
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  addvendor() {
    this.router.navigate(['add-Serviceoffered']);
  }



  getMembershipReport(data) {
    this.loginservice.getMembershipReport(data, this.currentUser, '8')
      .subscribe(
        data => {
          if (data['data'].length > 0) {
            this.dataresult = data['data'];
            this.certList.contractorId = this.model['Id'];
            this.certList.uid = this.currentUser['uid'];
            this.certificate = data;
            this.showLoader = false;
            let tableArr: Element[] = data['data'];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          } else {
            this.dataresult.length = 0;
            // this._flashMessagesService.show('No Subcontractors!', { cssClass: 'alert-danger' });
            // this.router.navigate(['addlowertier']);
            this.showLoader = false;
            let tableArr: Element[] = [];
            this.dataSource = new MatTableDataSource(tableArr);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          }
        },
        error => {
          alert('Network Error getMembershipReport API');
          this.showLoader = false;
        });
  }


  // Angular component code
  handleClick(columnId: string, element: any) {
    switch (columnId) {
      // case 'edit':
      //   this.edit(element.vendor_id);
      //   break;
      // case 'view':
      //   this.view(element.vendor_id);
      //   break;
      case 'delete':
        this.delete(element.vendor_id);
        break;
      default:
        break;
    }
  }

  delete(service_category_id: number) {
    // Handle delete action
    // alert('delete');
    // alert(service_category_id);
    if (confirm('Deleting of this Service Offered is done from the entire system')) {
      if (confirm('Are you sure want to delete')) {
        this.loginservice.deletegridDataNew(service_category_id, 'service_category_id', 'service_offered', 'status', '1').subscribe(data => {
          this._flashMessagesService.show('Deleted Successfully', { cssClass: 'alert-success' });
          this.ngOnInit();
        },
          error => {
            alert('Error in delete');
            this.showLoader = false;
          });
      }
    }
  }

  search() {
    let data = {
      f_name: this.model['f_name'],
      phone: this.model['phone'],
      service_category: this.model['service_category'],
    };
    this.getMembershipReport(data)
  }

  reset() {
    this.model['start_date'] = '';
    this.model['end_date'] = '';
    this.model['bill_no'] = '';
    this.ngOnInit();
  }

  changeRecordPerPage(value) {
    this.recordsperpage = value;
  }

  tableToExcel(table, excelName) {
    let list: any = [];
    var exports1 = [];
    this.datass = this.dataresult;
    exports1 = this.dataresult;
    let sno = 0;
    exports1.forEach(element => {
      sno = sno + 1;
      list.push({ '#': sno, 'Customer Name': element.f_name, 'Phone': element.phone, 'Total Visit': element.total_visit, 'Total Service': element.total_service });
    });
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(list);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    XLSX.writeFile(workbook, excelName + '.xls', { bookType: 'xls', type: 'buffer' });
  }

  sortable(sort) {
    let order = ""
    if (this.sortOrder == 0) {
      order = "DESC";
      this.sortOrder = 1;
    } else {
      order = "ASC";
      this.sortOrder = 0;
    }
    let data = {
      start_date: this.model['start_date'],
      end_date: this.model['end_date'],
      bill_no: this.model['bill_no'],
      f_name: this.model['f_name'],
      phone: this.model['phone'],
      sort: sort,
      sortOrder: order
    };
    this.getMembershipReport(data)
  }

  refund(covenant, status) {
    if (status === '3') {
      var msg = 'Are you sure want to refund the membership?';
    } else {
      var msg = 'Are you sure want to rejoin the membership?';
    }
    if (confirm(msg)) {
      let data = {
        mmmmid: covenant.mmmmid,
        status: status,
        uid: this.currentUser['uid']
      };
      this.loginservice.refundMembership(data, this.currentUser)
        .subscribe(
          data => {
            this._flashMessagesService.show('Status Changed Successfully', { cssClass: 'alert-success' });
            this.ngOnInit();
          },
          error => {
            alert('Network Error refundMembership API');
            this.showLoader = false;
          });
    }
  }

  roundGst(value) {
    return Math.round(value);
  }

  totalAmount(covenant): number {
    const memAmt = Number(covenant.memAmt);
    const tax = Number(this.cgst) + Number(this.sgst);
    return Math.round(memAmt + (memAmt * tax) / 100);
  }
}



// WEBPACK FOOTER //
// ./src/app/package-report/package-report.component.ts